/*
	Collection Filtering Functions
*/
var CURRENT_FILTERS = new Object();

/* test filters */
//CURRENT_FILTERS.push("tag_fg_genre_jazz");

function updateClearFiltersVisibility() {
  if (Object.keys(CURRENT_FILTERS).length === 0) {
    $(".clear-filters").hide();
  } else {
    $(".clear-filters").show();
  }
}
//hide products not matching the current filters
function collection_filter(looping) {
  if (Object.keys(CURRENT_FILTERS).length == 0) {
    $("#collection-empty").hide();
    $(".collection-product").removeClass("filtering").show();
    $(".collection-product").css("clear", "none");

    // Use the accessible count update even when no filters are active
    const totalProducts = $(".collection-product").length;
    updateAccessibleProductCount(totalProducts);

      // ✅ Keep button visibility updated
    updateClearFiltersVisibility();

    return totalProducts;
  }


  $(".collection-product").addClass("filtering");

  var this_selector = "";
  var filter_group_selector = "";
  for (var this_filter_group in CURRENT_FILTERS) {
    this_selector = "";
    $(".collection-product" + "." + this_filter_group + "-matched").removeClass(this_filter_group + "-matched");
    filter_group_selector += "." + this_filter_group + "-matched";
    for (this_filter in CURRENT_FILTERS[this_filter_group]) {
      if (this_selector != "") this_selector += ",";
      this_selector += ".collection-product." + this_filter_group + "." + CURRENT_FILTERS[this_filter_group][this_filter];
    }

    $(this_selector).addClass(this_filter_group + "-matched");
  }

  $(".collection-product" + filter_group_selector).removeClass("filtering").show();
  $(".collection-product.filtering").hide().removeClass("filtering");
  $(".collection-product").css("clear", "none");

  const products_returned = $(".collection-product:visible").length;

  // ✅ Accessible count update here
  updateAccessibleProductCount(products_returned);

  if (products_returned > 0) {
    $("#collection-empty").hide();

    if (products_returned < PAGE_LIMIT) {
      collection_page_load(true);
    }
  } else {
    collection_page_load(true);
  }
    // ✅ Update button visibility even after filtering
  updateClearFiltersVisibility();

  return products_returned;
}

let announceTimeout;
function updateAccessibleProductCount(count) {
  clearTimeout(announceTimeout);

  announceTimeout = setTimeout(() => {
    const alertText = `Showing ${count} products`;
    $("#product-count-alert").text(alertText);
    $(".product-count").show();
  }, 300); // Delay ensures screen reader doesn't speak too early
}


function tracks_display(tracks_url)
{
	$.getJSON( tracks_url, function( data )
	{
		for(side_var in data)
		{
			this_disc = '<div class="disc-list">';
			if(Object.keys(data).length > 1) this_disc += '<p>' + side_var + '</p>';
			this_disc += '<ol>';
			for(track in data[side_var])
			{
				if(jQuery.trim(data[side_var][track]) != "")
					this_disc += '<li>' + data[side_var][track] + '</li>'
			}
			this_disc += '</ol>';
			$("#track-listing .accordion-content").append(this_disc);
			$("#track-listing").show();
		}		
	});
}

function collection_page_load_page(page_number, looping)
{
	$(".page-load-control").remove();
	var sorting = ("sort_by" in Shopify.queryParams) ? Shopify.queryParams["sort_by"] : "";
	var next_page_url = document.location.href.replace('#','');
	if(next_page_url.indexOf("?") < 0) next_page_url += "?page_next=1";
	next_page_url += "&view=data";
	if("page" in Shopify.queryParams)
		next_page_url.replace(/(page=).*?(&)/,'$1' + page_number + '$2');
	else
		next_page_url += "&page=" + page_number;
	
	$.get(next_page_url, function( data )
	{
		if(data.indexOf("*EMPTY*") == -1)
		{
			$("#collection-data .grid-uniform").append(data);			
			collection_filter(looping);
		}
      	else
        {
          products_returned = $(".collection-product:visible").length;
    	  if(products_returned == 0)
            $("#collection-empty").show();
        }
	});
}

function collection_page_load(looping)
{
	collection_page_load_page(++PAGE_NUMBER, looping);
}

function build_filters(page_number)
{
	var sorting = ("sort_by" in Shopify.queryParams) ? Shopify.queryParams["sort_by"] : "";
	var filters_page_url = document.location.href.replace('#','');
	if(filters_page_url.indexOf("?") < 0) filters_page_url += "?page_next=1";
	filters_page_url += "&view=filters";
	if("page" in Shopify.queryParams)
		filters_page_url.replace(/(page=).*?(&)/,'$1' + page_number + '$2');
	else
		filters_page_url += "&page=" + page_number;
	$.get(filters_page_url, function( data )
	{
		var filters = JSON.parse(data);
      	var this_count = parseInt($(".product-count span").text());
      	this_count += filters.product_count_available;
      	$(".product-count span").text(this_count);
		/*for(filter_group in filters.filter_groups)
		{
			this_fg = filters.filter_groups[filter_group];
			if(!$(".filter-groups-container .accordion-container[data-filter-group-name='" + this_fg.filter_group + "']").length)
			{	
				filter_group_append = '<div class="accordion-container" data-filter-group-name="' + this_fg.filter_group + '">';
				filter_group_append += '<a href="#" class="accordion-toggle">' + this_fg.filter_group + ' <span class="toggle-icon"><i class="icon icon-plus"></i></span></a>';
				filter_group_append += '<div class="accordion-content filter-group-groups" ></div>';
				filter_group_append += '</div>';		
				$(".filter-groups-container").append(filter_group_append);		
			}
			
			for(filters_i in this_fg.filters)
			{
				this_filter = this_fg.filters[filters_i];
				if(this_filter.filter == "X") continue;
				if(!$(".filter-groups-container .accordion-container[data-filter-group-name='" + this_fg.filter_group + "'] .filter-group-groups a[data-filter='" + this_filter.filter + "']").length)
				{
					filter_append = '<a href="javascript:void(0);" class="collection-filter" data-filter-group="' + this_filter.filter_group + '" data-filter="' + this_filter.filter + '">' + this_filter.display + '</a>';
					$(".filter-groups-container .accordion-container[data-filter-group-name='" + this_fg.filter_group + "'] .filter-group-groups").append(filter_append);
				}
			}			
		}*/
		for(meta_field in filters.meta_fields)
		{
			this_mf = filters.meta_fields[meta_field];
            if(this_mf.meta_field == "file_under")
            {
				if($(".filter-groups-container .accordion-container[data-filter-group-name='Alpha Group']").length)
                {	                    
                  for(mf_i in this_mf.meta_values)
                  {
                      this_val = this_mf.meta_values[mf_i];                      
                      if(this_val == "XX") continue;
                      if(!isLetter(this_val))
                        this_val = "%230-10";
                      this_filter = "tag_file_under_" + this_val.replace('%','PERCENT');
                      if(!$(".filter-groups-container .accordion-container[data-filter-group-name='Alpha Group'] .filter-group-groups a[data-filter='" + this_filter + "']").length)
                      {
                          filter_append = '<a href="javascript:void(0);" data-sort="' + decodeURIComponent(this_val) + '" class="collection-filter" data-filter-group="tag_file_under" data-filter="' + this_filter + '">' + decodeURIComponent(this_val)  + '</a>';
                          $(".filter-groups-container .accordion-container[data-filter-group-name='Alpha Group'] .filter-group-groups").append(filter_append);
                      }
                  }	
                  if(this_mf.meta_values.length > 1)
                  {
                    $(".filter-groups-container .accordion-container[data-filter-group-name='Alpha Group']").show();
                    var new_order = $(".filter-groups-container .accordion-container[data-filter-group-name='Alpha Group'] .filter-group-groups a").sort(function (a, b) {
                        return String.prototype.localeCompare.call($(a).attr('data-sort').toLowerCase(), $(b).attr('data-sort').toLowerCase());
                     });
                    $(".filter-groups-container .accordion-container[data-filter-group-name='Alpha Group'] .filter-group-groups").html(new_order);
                  }
                }
            }
		}
		for(variation_group in filters.variation_groups)
		{
			this_vg = filters.variation_groups[variation_group];	
          
          	//don't display Size filter
          	if(this_vg.variation_group == 'Size') continue;
          
			if(!$(".variation-groups-container .accordion-container[data-variation-group-name='" + this_vg.variation_group + "']").length)
			{	
              	variation_group_append = '<div class="accordion-container" style="display:none;" data-variation-group-name="' + this_vg.variation_group + '">';
				variation_group_append += '<a href="#" class="accordion-toggle">' + this_vg.variation_group + ' <span class="toggle-icon"><i class="icon icon-plus"></i></span></a>';
				variation_group_append += '<div class="accordion-content filter-group-groups" ></div>';
				variation_group_append += '</div>';		
				$(".variation-groups-container").append(variation_group_append);		
			}
			
          	var filters_count = 0;
			for(variations_i in this_vg.variations)
			{
				this_variation = this_vg.variations[variations_i];              	
				if(this_variation.variation == "X") continue;
				if(!$(".variation-groups-container .accordion-container[data-variation-group-name='" + this_vg.variation_group + "'] .filter-group-groups a[data-filter='" + this_variation.variation + "']").length)
				{
					variation_append = '<a href="javascript:void(0);" class="collection-filter" data-filter-group="' + this_variation.variation_group + '" data-filter="' + this_variation.variation + '" data-filter-display="' + this_variation.display + '">' + this_variation.display + '</a>';
					$(".variation-groups-container .accordion-container[data-variation-group-name='" + this_vg.variation_group + "'] .filter-group-groups").append(variation_append);
                  	filters_count++;
                  	if(filters_count > 1)
                    {
                      $(".variation-groups-container .accordion-container[data-variation-group-name='" + this_vg.variation_group + "']").show();
                      $("#filters-title").show();
                    }
				}
			}			
		}
      
      	if(filters.product_count == 0 && $(".variation-groups-container .accordion-container[data-variation-group-name='Size']").length)
        {
          var size_filters = [];
          var this_size_option = "";
          var sizes_html = $(".variation-groups-container .accordion-container[data-variation-group-name='Size']").html();
          $(".variation-groups-container-temp").html(sizes_html);
          $(".variation-groups-container-temp .accordion-content").each(function()
		  {
            sizes = POSSIBLE_SIZES.split(',');
          	for(size_option in sizes)
            {
              this_size_option = sizes[size_option];
              var size_index = 0;
              $(this).find(".collection-filter").each(function() 
              {
                if(this_size_option == $(this).attr('data-filter-display'))
                {
                  size_filters.push(size_index);
                  return true;
                }
                
                size_index++;;
              });
            }
          });
          
          //console.log(size_filters);
          
          if(size_filters.length)
          {
            $(".variation-groups-container .accordion-container[data-variation-group-name='Size'] .accordion-content").empty(); 
            for(size_filter in size_filters)
            {
              //console.log($(".variation-groups-container-temp .accordion-content .collection-filter").get(size_filters[size_filter]));
              $(".variation-groups-container .accordion-container[data-variation-group-name='Size'] .accordion-content").append($(".variation-groups-container-temp .accordion-content .collection-filter").clone().get(size_filters[size_filter]));
            }
          }
        }
            

		if(filters.product_count > 0)
			build_filters(++page_number);
      	else
          $(".product-count").show();
	});
}

function isLetter(str)
{
  return str.length === 1 && str.match(/[a-z]/i);
}

function update_quantity(id, qty) {
  // Add activity classes when changing cart quantities
  var row = $('.ajaxcart__row[data-id="' + id + '"]').addClass('is-loading');

  if (qty === 0) {
    row.parent().addClass('is-removed');
  }

  // Slight delay to make sure removed animation is done
  setTimeout(function() {
    ShopifyAPI.changeItem(id, qty, ajaxCart.adjustCartCallback);
  }, 250);
}

function newsletter_validate(form)
{
  var email = $(form).find("#mail");
  var zip = $(form).find("#zip");
  var input_valid = true;
  if(jQuery.trim($(email).val()) == "")
  {
    input_valid = false;
    $(email).addClass('input-error-required');
  }
  /*if(jQuery.trim($(zip).val()) == "")
  {
    input_valid = false;
    $(zip).addClass('input-error-required');
  }*/
  
  return input_valid;
}

$(document).ready(function () {
    // PAGE_LIMIT = 2;
    
    // Existing collection filter logic
    $('body').on('click', '.collection-filter', function() {
        var this_filter = $(this).attr('data-filter');
        var this_filter_group = $(this).attr('data-filter-group');
        if (typeof this_filter == "undefined" || typeof this_filter_group == "undefined") return false;
        
        if (Object.keys(CURRENT_FILTERS).length == 0 && $("#collection-empty").is(":visible")) return false;
        
        if ($(this).hasClass("collection-filter-active")) {
            $(this).removeClass("collection-filter-active").removeAttr("aria-pressed");
            CURRENT_FILTERS[this_filter_group].splice(CURRENT_FILTERS[this_filter_group].indexOf(this_filter), 1);
            if (CURRENT_FILTERS[this_filter_group].length == 0)
                delete CURRENT_FILTERS[this_filter_group];
        } else {
            if (!(this_filter_group in CURRENT_FILTERS)) CURRENT_FILTERS[this_filter_group] = [];
            $(this).addClass("collection-filter-active").attr("aria-pressed", "true");
            CURRENT_FILTERS[this_filter_group].push(this_filter);
        }
        
        products_returned = collection_filter(false);
    });
    
    // Handle clear filters button click
    $('#clear-filters').on('click', function() {
        // Clear all filters
        CURRENT_FILTERS = {}; // Reset the filter object

        // Remove active classes from all filter buttons
        $('.collection-filter').removeClass('collection-filter-active').removeAttr('aria-pressed');
        
        // Reset the product display
        products_returned = collection_filter(false);
       // ✅ Add this line
    updateClearFiltersVisibility();
    });

    // Other existing event listeners and functions...
  
    if ($("#track-listing").length > 0 && typeof TRACKS_URL != "undefined") {
        tracks_display(TRACKS_URL);
    }

    if ($(".variation-groups-container").length)
        build_filters(1);

    var products_returned = $(".collection-product:visible").length;

    if (products_returned > 0) {
        if (products_returned < PAGE_LIMIT)
            collection_page_load(true);
    }
});

updateClearFiltersVisibility();

function cart_display_adjust(cart) {
  var $elem = $(".free-shipping-meter");
  if($elem.length && (typeof $elem.data('min') !== "undefined"))
  {
    var shipping_min = parseFloat($elem.data('min')), cart_total = cart.total_price/100, percentage = 0;
    if(shipping_min && (typeof shipping_min != "undefined") && shipping_min != 0 && shipping_min > 0)     
    {
    	percentage = parseFloat(cart_total/shipping_min)*100;
      	if(percentage > 0)
        {
          $(".free-shipping-meter").removeClass('achieved');
          $(".free-shipping-meter-display").show();
          if(percentage >= 20)
            $(".free-shipping-meter-level").text("$" + cart_total);
          if(percentage >= 100)
          {
            percentage = 100;
            $(".free-shipping-meter-display").hide();
            $(".free-shipping-meter").addClass('achieved');
          }    
          $(".free-shipping-meter-level").css('width',percentage + "%");
          $(".free-shipping-meter-display").text("$" + shipping_min);
          $(".free-shipping-meter").show();
        }
      	else
          $(".free-shipping-meter").hide();
    }    
  }
}

var entityMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': '&quot;',
    "'": '&#39;',
    "/": '&#x2F;'
  };

function escapeHtml(string) {
    return String(string).replace(/[&<>"'\/]/g, function (s) {
      return entityMap[s];
    });
  }